import React from "react";
import { Filter } from "../../common/components/Filter";
import withRouter from "../../common/hooks/withRouter";
import { connect } from "react-redux";
import { setKYBTestcacheRecordsFilter, updateKYBTestcacheFilters } from "../actions/KYBTestCacheActions";

export class KYBTestCacheSidebarFilters extends React.Component {

    handleCountryFilter = (filterOption) => {
        this.props.setKYBTestcacheRecordsFilter(filterOption, "country");
        this.props.updateKYBTestcacheFilters();
    }

    handleDataSourceFilter = (filterOption) => {
        this.props.setKYBTestcacheRecordsFilter(filterOption, "datasource");
        this.props.updateKYBTestcacheFilters();
    }

    render() {
        return (
            <div className="sidebar-filter-container">
                <Filter
                    placeholder="Country"
                    handleFilter={this.handleCountryFilter}
                    options={this.props.kybTestcacheFilterOptions.kybTestcacheCountryOptions}
                    value={this.props.kybTestcacheFilters.kybTestcacheCountryFilter}
                />
                <Filter
                    placeholder="Data Source"
                    handleFilter={this.handleDataSourceFilter}
                    options={this.props.kybTestcacheFilterOptions.kybTestcacheDataSourceOptions}
                    value={this.props.kybTestcacheFilters.kybTestcacheDataSourceFilter}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    kybTestcacheFilterOptions: state.support.kybTestcache.kybTestcacheFilterOptions,
    kybTestcacheFilters: state.support.kybTestcache.kybTestcacheFilters,
});

const mapDispatchToProps = dispatch => ({
    setKYBTestcacheRecordsFilter: (filterOption, type) => { dispatch(setKYBTestcacheRecordsFilter(filterOption, type)) },
    updateKYBTestcacheFilters: () => { dispatch(updateKYBTestcacheFilters()) },
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYBTestCacheSidebarFilters))
